import { GET_SERVICE_TYPES_SUCCESS } from '../management/ManagementConstants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { tabNames } from '../../pages/member/Constants'
import { LOGOUT } from '../../app/authState'
import {
  CLEAR_RESEND_SUCCESS,
  DELETE_MEMBER,
  DELETE_MEMBER_ERROR,
  DELETE_MEMBER_SUCCESS,
  GET_MEMBER,
  GET_MEMBER_ERROR,
  GET_MEMBER_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_ERROR,
  GET_SERVICE_TYPES_SUCCESS_MEMBER,
  OVERWRITE_MEMBER_PRODUCTIVITY,
  OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS,
  RESEND_INVITE,
  RESEND_INVITE_ERROR,
  RESEND_INVITE_SUCCESS,
  RESET,
  SET_EDITED_MEMBER_DATA,
  SET_ERROR,
  SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS,
  SET_MEMBER,
  SET_MEMBER_ACTIVATION,
  SET_MEMBER_ACTIVATION_ERROR,
  SET_MEMBER_ACTIVATION_SUCCESS,
  SET_PHONE_VALIDATION,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  VALIDATE_PHONE_NUMBER_SUCCESS,
} from './MemberConstants'
import { apiErrorCodes } from '../../utils/apiHelper'

const initialState = {
  members: [],
  error: '',
  serviceTypes: [],
  loading: false,
  serviceLoading: false,
  deleteSuccess: false,
  resendInviteSuccess: false,
  isProductivityOverwrittenSuccess: false,
  defaultServerErrorMessage: '',
  phoneIsValid: null,
  tabs: [
    { name: tabNames.GENERAL, isActive: true },
    { name: tabNames.LICENSE_AND_PRODUCTIVITY, isActive: false },
    { name: tabNames.CALENDAR, isActive: false },
  ],
}

export default function memberReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_MEMBER:
    case DELETE_MEMBER:
    case RESEND_INVITE:
    case SET_MEMBER_ACTIVATION:
    case OVERWRITE_MEMBER_PRODUCTIVITY:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      }
    case OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData?.userId]: { ...state.members[action.extraData.userId], ...action.payload.data },
        },
        isProductivityOverwrittenSuccess: true,
      }
    case SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isProductivityOverwrittenSuccess: action.payload,
      }
    case VALIDATE_PHONE_NUMBER:
      return {
        ...state,
        loading: true,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.UserId]: { ...state.members[action.extraData.UserId], phoneIsValid: null },
        },
      }
    case SET_EDITED_MEMBER_DATA:
      return {
        ...state,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.id]: { ...state.members[action.payload.id], ...action.payload.data },
        },
      }
    case SET_MEMBER_ACTIVATION_SUCCESS:
      return {
        ...state,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.UserId]: {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...state.members[action.extraData.UserId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            IsActive: action.extraData.willActivate,
          },
        },
        loading: false,
      }
    case GET_SERVICE_TYPES:
      return {
        ...state,
        serviceLoading: true,
      }
    case VALIDATE_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.UserId]: { ...state.members[action.extraData.UserId], phoneIsValid: true },
        },
      }
    case RESET: {
      return {
        ...initialState,
        serviceTypes: state.serviceTypes,
      }
    }
    case RESEND_INVITE_SUCCESS:
      return {
        ...state,
        resendInviteSuccess: true,
        loading: false,
      }
    case DELETE_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
      }
    case GET_MEMBER_SUCCESS: {
      const currentMembers = { ...state.members }
      // @ts-expect-error TS7015 -- MIGRATION: not approved, fix when encountered
      currentMembers[`${action.payload.UserId}`] = { ...action.payload, ...action.extraData }
      return {
        ...state,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.UserId]: { ...action.payload, ...action.extraData, phoneIsValid: null },
        },
        loading: false,
      }
    }
    case GET_SERVICE_TYPES_SUCCESS_MEMBER:
    case GET_SERVICE_TYPES_SUCCESS:
      return {
        ...state,
        serviceLoading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        serviceTypes: [...action.payload],
      }
    case GET_SERVICE_TYPES_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        serviceLoading: false,
        defaultServerErrorMessage,
      }
    }
    case RESEND_INVITE_ERROR:
    case DELETE_MEMBER_ERROR:
    case VALIDATE_PHONE_NUMBER_ERROR:
    case SET_MEMBER_ACTIVATION_ERROR:
    case GET_MEMBER_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case apiErrorCodes.PHONE_NUMBER_NOT_VALID:
            return {
              ...state,
              loading: false,
              members: {
                ...state.members,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                [action.extraData.UserId]: { ...state.members[action.extraData.UserId], phoneIsValid: false },
              },
            }
          case apiErrorCodes.THIRD_PARTY_ERROR:
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            const { ErrorCode, ErrorMessage } = action.payload.Data
            message = `${ErrorCode} - ${ErrorMessage}`
            return {
              ...state,
              loading: false,
              error: message,
              members: {
                ...state.members,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                [action.extraData.UserId]: { ...state.members[action.extraData.UserId], phoneIsValid: false },
              },
            }
          case apiErrorCodes.PHONE_NUMBER_NOT_UNIQUE:
            return {
              ...state,
              loading: false,
              error: getUserFriendlyErrorMessage(errorCodes.PROVIDER_NUMBER_NOT_UNIQUE),
            }
          case 'UserActivated':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(null, 'UserActivated')
            break

          case 'UserNotFound':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'User')
            break
          case 'ProviderNotFound':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Provider')
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case SET_MEMBER: {
      const currentMembers = state.members ? { ...state.members } : {}
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      currentMembers[action.payload.UserId] = {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        ...currentMembers[action.payload.UserId],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...action.payload,
      }
      return {
        ...state,
        members: { ...currentMembers },
      }
    }
    case CLEAR_RESEND_SUCCESS:
      return {
        ...state,
        resendInviteSuccess: false,
      }
    case SET_PHONE_VALIDATION:
      return {
        ...state,
        members: {
          ...state.members,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.UserId]: {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...state.members[action.payload.UserId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            phoneIsValid: action.payload.value,
          },
        },
      }
    case SET_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode) {
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, action.payload.extra),
          defaultServerErrorMessage: '',
        }
      }
      return {
        ...state,
        error: '',
        defaultServerErrorMessage: '',
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
